import { render, staticRenderFns } from "./notificationNav.vue?vue&type=template&id=326ef8ba&"
import script from "./notificationNav.vue?vue&type=script&lang=js&"
export * from "./notificationNav.vue?vue&type=script&lang=js&"
import style0 from "./notificationNav.vue?vue&type=style&index=0&id=326ef8ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports